export default __webpack_public_path__ + "static/media/xSCREAM.0d27e244.png";